<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full">
      <h1>Bestellung bewerten</h1>
      <p class="mb-6 text-sm leading-tight text-grey-dark">Schön, dass Du dir einen Moment für die Bewertung deiner Bestellung nimmst. Fangen wir gleich an:</p>

      <div v-if="finished" class="mt-8 flex items-center bg-green-heinz text-black text-sm font-bold px-4 py-3" role="alert">
        <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
        <p>Vielen Dank für deine Bewertung. Sie hilft anderen Nutzern bei der Auswahl des Lieferservices.</p>
      </div>

      <div v-if="!isRateable" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm"><p>
        Die Bestellung kann erst bewertet werden, wenn das Restaurant die Lieferzeit bestätigt hat.
      </p></div>

      <div v-if="!isRateableByHost" class="bg-grey-lightest border-l-4 border-green p-4 mb-8 text-sm"><p>
        Das gewählte Restaurant hat die Bewertungen deaktiviert.
      </p></div>

      <form v-if="isRateable && isRateableByHost && !finished" name="review">
        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-quality">
            Wie zufrieden warst Du mit der Qualität der Speisen?
          </label>
          <div class="relative">
            <select v-model="quality" class="max-w-md block appearance-none w-full border border-green text-grey-darker py-3 px-4 pr-8 rounded" id="grid-quality">
              <option value="1">Sehr zufrieden</option>
              <option value="2">Zufrieden</option>
              <option value="3">Einigermaßen zufrieden</option>
              <option value="4">Nicht so zufrieden</option>
              <option value="5">Unzufrieden</option>
              <option value="5">Sehr unzufrieden</option>
            </select>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-time">
            Wie zufrieden warst Du mit der Lieferzeit?
          </label>
          <div class="relative">
            <select v-model="time" class="max-w-md block appearance-none w-full border border-green text-grey-darker py-3 px-4 pr-8 rounded" id="grid-time">
              <option value="1">Sehr zufrieden</option>
              <option value="2">Zufrieden</option>
              <option value="3">Einigermaßen zufrieden</option>
              <option value="4">Nicht so zufrieden</option>
              <option value="5">Unzufrieden</option>
              <option value="5">Sehr unzufrieden</option>
            </select>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-city">
            Wie zufrieden warst Du mit dem Preis-/Leistungsverhältnis?
          </label>
          <div class="relative">
            <select v-model="price" class="max-w-md block appearance-none w-full border border-green text-grey-darker py-3 px-4 pr-8 rounded" id="grid-city">
              <option value="1">Sehr zufrieden</option>
              <option value="2">Zufrieden</option>
              <option value="3">Einigermaßen zufrieden</option>
              <option value="4">Nicht so zufrieden</option>
              <option value="5">Unzufrieden</option>
              <option value="5">Sehr unzufrieden</option>
            </select>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-reorder">
            Würdest Du bei diesem Lieferservice nochmal bestellen?
          </label>
          <div class="relative">
            <select v-model="reorder" class="max-w-md block appearance-none w-full border border-green text-grey-darker py-3 px-4 pr-8 rounded" id="grid-reorder">
              <option value="100">Ja</option>
              <option value="50">Vielleicht</option>
              <option value="0">Nein</option>
            </select>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-comment">
            Möchtest Du noch etwas loswerden? Raus damit:
          </label>
          <div class="relative">
            <textarea v-model="comment" class="max-w-md appearance-none block w-full h-32 text-grey-darker border border-green rounded py-3 px-4" id="grid-comment"></textarea>
          </div>
        </div>

        <div class="w-full mb-8">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-comment">
            Du hast ein Foto von deinem Essen? Gerne her damit!
          </label>
          <div class="relative">
            <!-- <input type="file" name="image" accept="image/*" @change="image = $event.target.files[0]" /> -->
            <image-upload-resizer
                name='image'
                :max-width="1280"
                :max-height="1280"
                :class-name="['form-control-file']"
                accept="image/*"
                capture="camera"
                doNotResize="['gif', 'svg']"
            ></image-upload-resizer>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold">
            <input type="checkbox" v-model="publicName" />
            Bewertung veröffentlichen als
            <span v-if="publicName" class="underline">
              {{ userData.item_vorname }}
              <template v-if="userData.item_ort_einfach"> aus {{ userData.item_ort_einfach }}</template>
            </span>
            <span v-if="!publicName" class="underline">anonymer Nutzer</span>
          </label>
        </div>

        <button v-if="!loading" v-on:click="sendreview" class="max-w-md bg-green-heinz hover:bg-green-heinz-light text-black py-4 px-2 mb-8 w-full rounded">Bewertung abschließen</button>
      </form>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'
import ImageUploadResizer from '../../components/ImageUploadResizerComponent.vue'

export default {
  name: 'Review',

  data () {
    return {
      loading: false,
      isRateable: true,
      isRateableByHost: true,
      finished: false,
      quality: 1,
      time: 1,
      price: 1,
      reorder: 100,
      comment: '',
      publicName: true,
      userData: {}
    }
  },

  components: {
    'ImageUploadResizer': ImageUploadResizer
  },

  mounted () {
    this.getUserData()
  },

  methods: {
    getUserData () {
      axios.post(endpoints.ratingDetails, {
        'orderId': this.$route.params.orderId,
        'checksum': this.$route.params.checksum
      }).then(({data}) => {
        this.userData = data
        if(data.item_review === 'disallow') this.isRateableByHost = false
        if(data.item_delivery_time === '0000-00-00 00:00:00') {
          this.isRateable = false
        }
      })
      .catch(() => {
        this.isRateable = false
      })
    },

    sendreview (e) {
      e.preventDefault()
      this.loading = true

      axios.post(endpoints.review, {
        'orderId': this.$route.params.orderId,
        'checksum': this.$route.params.checksum,
        'quality': this.quality,
        'time': this.time,
        'price': this.price,
        'reorder': this.reorder,
        'comment': this.comment,
        'publicName': this.publicName
      }).then(({data}) => {
        if (typeof data.exception === 'string') {
          alert(data.exception)
        } else {
          this.finished = true
          this.sendImages()
        }

        this.loading = false
      })
    },

    sendImages () {
      const image = document.getElementById('media_file').files[0]
      if (image === null) return

      const formData = new FormData()
      formData.set('orderId', this.$route.params.orderId)
      formData.set('checksum', this.$route.params.checksum)
      formData.set('image', image)

      axios.post(endpoints.reviewAddImage, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/review/create.vue